import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as Void0$SolvuuApi0 from "./void0.bs.js";
import * as Caml_builtin_exceptions from "bs-platform/lib/es6/caml_builtin_exceptions.js";

function read_t(param) {
  return Pervasives.failwith(Void0$SolvuuApi0.deserialize_err_msg);
}

function write_t(param) {
  throw [Caml_builtin_exceptions.assert_failure,
  /* tuple */
  ["void_bs.ml", 4, 16]];
}

export { read_t, write_t };
/* No side effect */